import styled from 'styled-components';
import { color } from '../../resources';

export const StyledContainer = styled.div`
  background-color: ${color.white};
  padding: 40px 10%;
  @media (max-width: 768px) {
    padding: 20px 5%;
  }
`;

export const StyledContainerTitle = styled.div`
  background-color: #48bcb0;
  padding: 60px 20%;
  @media (max-width: 768px) {
    padding: 26px 6%;
  }
`;
export const StyledContainerDescription = styled.div`
  background-color: ${color.white};
  padding: 20px 3%;
`;

export const StyledContainerCalendar = styled.div`
  background-color: ${color.white};
  padding: 12px !important;
  border: 1px solid #c1c1c1 !important;
  border-radius: 10px !important;

  .ant-select-selector {
    height: auto !important;
  }

  .ant-radio-button-wrapper {
    span {
      vertical-align: bottom;
    }
  }
`;

export const StyledContainerBlock = styled.div`
  background-color: ${color.white};
  padding: 20px 12px;
  border: 1px solid #c1c1c1;
  border-radius: 10px;
`;
